import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import axiosInstance from "../../../../Fbaseurl";
import { showToast } from "../../../../store/reducers/ToastMessageReducer";

import "./index.css";
import Button from "../../../components/CommonComponents/Button";
import CloseIcon from "@mui/icons-material/Close";
import support from "../../../../assets/support.svg";
import InputField from "../InputField";
import RButton from "@mui/material/Button";
import supportUpload from "../../../../assets/supportUpload.svg";
import supportUploadDisabled from "../../../../assets/supportUploadDisabled.svg";

import FileIcon from "../../../../assets/FileIcon.svg";
import DeleteIcon from "../../../../assets/DeleteIcon.svg";
import { useDispatch } from "react-redux";

export default function ConfirmationPopup({ isPopupOpen, onCancel }) {
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const handleFileUpload = (event) => {
    var file = event.target.files[0];
    const maxAllowedSize = 5 * 1024 * 1024;
    if (file.size > maxAllowedSize) {
      dispatch(
        showToast({
          type: "error",
          message: "File size should be less than 5 MB",
        })
      )
      event.target.value = null
      return
    }
    setDocuments([...documents, file]);
    event.target.value = null;
  };
  const removeDocument = (item) => {
    setDocuments(documents.filter((a) => a.name !== item.name));
  };

  const submitQuery = async () => {
    const formData = new FormData();
    formData.append('query', query.trim());
    documents.forEach((value) => {
      formData.append('attachments', value);
    })
    try {
      setIsLoading(true);
      const response = await axiosInstance.post(
        "/Email/supportRequest",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response) {
        dispatch(
          showToast({
            message: "Query submitted successfully",
          })
        );
      }
    } catch (error) {
      dispatch(
        showToast({
          type: "error",
          message: 'Failed to submit the query. Please try again',
        })
      );
    }
    setIsLoading(false);
    onCancel();
  };

  useEffect(() => {
    setQuery("");
    setDocuments([]);
  }, [isPopupOpen]);
  return (
    <React.Fragment>
      <Dialog
        open={isPopupOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        sx={{ "& .MuiPaper-root": { borderRadius: "24px !important" } }}
      >
        <DialogTitle
          className="p-3"
          id="alert-dialog-title"
          sx={{ paddingBottom: "0px !important", backgroundColor: "#FFCC33" }}
        >
          <CloseIcon
            className="back-btn float-end"
            style={{ color: "#000" }}
            onClick={() => {
              onCancel();
            }}
          />
          <div className="d-flex justify-content-between gap-4 pt-2 pb-4">
            <img src={support} alt="support"></img>
            <div className="text-grey">
              <div className="fw-bold font-24">How can we help you!</div>
              <div className="font-16">
                Please provide your query or issue below, and we'll get back to
                you shortly.
              </div>
            </div>
          </div>
        </DialogTitle>
        <DialogContent className="p-4">
          <InputField
            name="query"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            title="Describe Your issue or Query"
            isRequired={false}
            type="text"
            className="form-control"
            multiline={true}
          />

          <RButton
            variant="outlined"
            size="medium"
            className="mt-3"
            color="secondary"
            sx={{
              textTransform: "none",
              borderRadius: "8px",
            }}
            component="label"
            disabled={documents.length === 3 ? true : false }
          >
            <img src={documents.length === 3 ? supportUploadDisabled : supportUpload} alt="upload"></img> Upload
            <input
              id="contained-button-file"
              multiple
              type="file"
              style={{ display: "none" }}
              onChange={handleFileUpload}
            />
          </RButton>
          <div className="d-flex flex-wrap gap-3 pt-3">
            {documents.map((item, index) => {
              return (
                <div className="d-flex p-1 fileName">
                  <img src={FileIcon} alt="file"></img>
                  <div className="px-1 my-auto font-14">{item.name}</div>
                  <img
                    src={DeleteIcon}
                    alt="delete"
                    onClick={() => removeDocument(item)}
                    className="cursor-pointer"
                  ></img>
                </div>
              );
            })}
          </div>
        </DialogContent>
        <hr></hr>
        <DialogActions className="mb-3 gap-3 d-flex justify-content-end mx-3">
          <Button
            variant=""
            // color="primary"
            label="Cancel"
            onClick={onCancel}
            className={`rounded-pill col-6 fw-bold py-1 `}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: '#FFF',
              color: '#000',
              border: '1px solid #000',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#f5f5f5', // subtle gray or keep #fff
                border: '1px solid #000',
                boxShadow: 'none',
              },
              '&:active': {
                boxShadow: 'none',
              },
              '&:focus': {
                boxShadow: 'none',
              },
            }}
          />
          <Button
            label="Submit"
            onClick={submitQuery}
            className={`rounded-pill col-6 fw-bold py-1 `}
            type="submit"
            // color="primary"
            variant="contained"
            disabled={!query.trim()}
            isLoading={isLoading}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              backgroundColor: '#FFCC33',
              color: '#000',
              borderColor: '#FFCC33',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#e6b800',
                borderColor: '#e6b800',
                boxShadow: 'none',
              },
              '&:active': {
                boxShadow: 'none',
              },
              '&:focus': {
                boxShadow: 'none',
              },
            }}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
